const STORAGE_KEY = 'od_saved_looks';

function readSavedLooks() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
}

function writeSavedLooks(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 80)));
  window.dispatchEvent(new CustomEvent('od:saved-looks-change'));
}

export function getSavedLooks() {
  return readSavedLooks();
}

export function isLookSaved(id) {
  return readSavedLooks().some((item) => String(item.id) === String(id));
}

export function toggleSavedLook(event) {
  const current = readSavedLooks();
  const exists = current.some((item) => String(item.id) === String(event.id));
  if (exists) {
    writeSavedLooks(current.filter((item) => String(item.id) !== String(event.id)));
    return false;
  }

  writeSavedLooks([
    {
      id: event.id,
      title: event.title,
      description: event.description,
      image_url: event.image_url,
      celebrity_name: event.celebrity_name,
      celebrity_slug: event.celebrity_slug,
      celebrity_image_url: event.celebrity_image_url,
      source_name: event.source_name,
      event_at: event.event_at,
      saved_at: new Date().toISOString(),
    },
    ...current,
  ]);
  return true;
}
